import React from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonStyles, Color } from '../../styles';
import BaseText from '../BaseText';
import RowView from '../RowView';
import Icon from '../Icon';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { REBOOK_ENABLED } from '../../config/env';
const InvoiceAirReceiptCard = ({ item = {}, multiPnrResp, passengerData }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('InvoiceAirReceiptCard');
  const requiredResponse =
    multiPnrResp &&
    Object.values(multiPnrResp)?.map((resp) => {
      const segments = resp?.AirResponseDetails?.AirLegs[0]?.AirSegments[0];
      const arrivalAirportCode = resp?.AirResponseDetails?.AirLegs[0]?.ArrivalAirportCode;
      return {
        ...segments,
        arrivalAirportCode: arrivalAirportCode,
      };
    });
  return (
    <View>
      {REBOOK_ENABLED
        ? requiredResponse?.map((airSegment) => {
            return (
              <View key={airSegment?.FlightNumber} style={CommonStyles.pt5}>
                <BaseText>
                  {airSegment?.AirlineName} #{airSegment?.FlightNumber}
                </BaseText>
                <RowView>
                  <BaseText>
                    {airSegment?.DepartureAirportCode} - {airSegment?.DepartureDate}{' '}
                    {airSegment?.DepartTime}{' '}
                  </BaseText>
                  <Icon name="arrowRight" />
                  <BaseText>
                    {' '}
                    {airSegment?.arrivalAirportCode} - {airSegment?.ArrivalDate}{' '}
                    {airSegment?.ArrivalTime}
                  </BaseText>
                </RowView>
                <RowView>
                  <BaseText> {t(tKey('OptionalServicesAndBaggageFees'))} </BaseText>
                  <BaseText> {airSegment?.AirCabinClass}</BaseText>
                </RowView>
                <View style={styles.seatView}>
                  {REBOOK_ENABLED ? null : (
                    <BaseText style={styles.seatText}>
                      {airSegment?.PassengerSeatMappingList[0]?.SeatNumber
                        ? airSegment?.PassengerSeatMappingList[0]?.SeatNumber
                        : 'NA'}
                    </BaseText>
                  )}
                </View>
                {/* <BaseText>Main Cabin Extra (+$27)</BaseText>
            <BaseText>Doc #: 1241221</BaseText> */}
                <BaseText>
                  {t(tKey('AirlineLocatorNumber'))}: {airSegment?.RecordLocator}{' '}
                </BaseText>
              </View>
            );
          })
        : item?.AirSegments.map((airSegment) => {
            return (
              <View key={airSegment?.FlightNumber} style={CommonStyles.pt5}>
                <BaseText>
                  {airSegment?.AirlineName} #{airSegment?.FlightNumber}
                </BaseText>
                <RowView>
                  <BaseText>
                    {airSegment?.DepartureAirportCode} - {airSegment?.DepartureDate}{' '}
                    {airSegment?.DepartTime}{' '}
                  </BaseText>
                  <Icon name="arrowRight" />
                  <BaseText>
                    {' '}
                    {airSegment?.ArrivalAirportCode} - {airSegment?.ArrivalDate}{' '}
                    {airSegment?.ArrivalTime}
                  </BaseText>
                </RowView>
                <RowView>
                  <BaseText> {t(tKey('OptionalServicesAndBaggageFees'))} </BaseText>
                  <BaseText> {airSegment?.AirCabinClass}</BaseText>
                </RowView>
                <View style={styles.seatView}>
                  {REBOOK_ENABLED ? null : (
                    <BaseText style={styles.seatText}>
                      {airSegment?.PassengerSeatMappingList[0]?.SeatNumber
                        ? airSegment?.PassengerSeatMappingList[0]?.SeatNumber
                        : 'NA'}
                    </BaseText>
                  )}
                </View>
                {/* <BaseText>Main Cabin Extra (+$27)</BaseText>
            <BaseText>Doc #: 1241221</BaseText> */}
                <BaseText>
                  {t(tKey('AirlineLocatorNumber'))}: {airSegment?.RecordLocator}{' '}
                </BaseText>
              </View>
            );
          })}
    </View>
  );
};
const styles = StyleSheet.create({
  seatView: {
    backgroundColor: Color.primary,
    width: '15%',
  },
  seatText: {
    textAlign: 'center',
    color: 'white',
  },
});

export default InvoiceAirReceiptCard;
